import { render } from "./DaySlotComponent.vue?vue&type=template&id=b93a0dd8"
import script from "./DaySlotComponent.vue?vue&type=script&lang=js"
export * from "./DaySlotComponent.vue?vue&type=script&lang=js"

import "./DaySlotComponent.vue?vue&type=style&index=0&id=b93a0dd8&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__